import { defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import palette from '../../../../shared/lib/theme/palette';
import { AddContactWrapper, flexCenter } from '../../../../shared/lib/theme/styleConstants';
import { formatPhoneNumber } from '../../../../shared/lib/utils';
import { useAppContext } from '../../app/contexts/AppContext';
import { DashboardCardProps, animateLayoutChangesType } from '../../app/interfaceTypes';
import { EditCardMenu } from '../menus/EditCardMenu';
import { CrownIcon } from '../../../../shared/lib/assets';
import { TOOLTIP_VIP_CONTACT_INFO } from '../../../../shared/lib/constants';
import { withTrademark } from '../../../../shared/lib/common/Tokenizer';
import { useMobileView } from '../../app/hooks/useMobileView';

const animateLayoutChanges = (args: animateLayoutChangesType) => (args.wasDragging ? defaultAnimateLayoutChanges(args) : true);

export const DashboardCard: FC<DashboardCardProps> = ({ contact, index, declined, handleVip, planName }) => {
  const { id, name, email, nickName, phoneNumber, priority } = contact ?? {};
  const { blackTwo, blackOne, lightThree } = palette;
  const mediumViewPort = useMobileView();
  const { dragAndDrop, isDragging } = useAppContext();

  const sortable = useSortable({
    id: id || '',
    animateLayoutChanges,
    transition: {
      duration: 350,
      easing: 'ease-in-out'
    },
    disabled: !dragAndDrop || mediumViewPort
  });

  const { attributes, listeners, setNodeRef, transform, transition } = sortable || {};

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: dragAndDrop ? (isDragging ? 'grabbing' : 'grab') : 'default'
  };

  return (
    <Box sx={{ ...AddContactWrapper, opacity: declined ? 0.8 : 1, position: 'relative' }} ref={setNodeRef} {...listeners} style={style} {...attributes}>
      {!declined && <EditCardMenu handleVip={handleVip} contactIndex={index} contact={contact} />}

      {!declined && priority === 1 && (
        <Tooltip title={withTrademark(TOOLTIP_VIP_CONTACT_INFO)}>
          <Box position="absolute" top="5px" left="10px" p={2}>
            <CrownIcon />
          </Box>
        </Tooltip>
      )}

      <Box height="178px" sx={{ ...flexCenter, flexDirection: 'column' }}>
        <Typography sx={{ color: blackTwo, marginBottom: '16px' }} variant="h2">
          {nickName}
        </Typography>

        <Typography sx={{ color: blackOne, fontWeight: '700', marginBottom: '5px' }} variant="body2">
          {formatPhoneNumber(phoneNumber)}
        </Typography>

        <Typography sx={{ color: blackTwo }} variant="subtitle2">
          {name}
        </Typography>

        <Typography sx={{ color: blackTwo }} variant="subtitle2">
          {email}
        </Typography>
      </Box>

      {!declined && (
        <Box position="absolute" left="10px" bottom="0px">
          <Typography variant="body2" sx={{ fontSize: '64px', fontWeight: '700', color: lightThree }}>
            {priority}
          </Typography>
        </Box>
      )}
      {planName && (
        <Box
          position="absolute"
          bottom="10px"
          left="50%"
          sx={{
            transform: 'translateX(-50%)', // centers horizontally
            textAlign: 'center'
          }}
        >
          {planName === 'Free plan' && (
            <Typography variant="subtitle2" sx={{ color: blackTwo, fontWeight: '600' }}>
              {planName}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};
